const InstagramEmbed = ({ id, type = "p", title, className = "" }) => (
    <div className={`w-full h-full overflow-hidden ${className}`} data-testid={`ig-embed-${id}`}>
        <iframe
            src={`https://www.instagram.com/${type}/${id}/embed`}
            title={title}
            loading="lazy"
            scrolling="no"
            allowTransparency
            className="w-full h-full border-0"
        />
    </div>
);

export default InstagramEmbed;
